import { FeatureFlag } from '@appTypes/PagesApi.interface'

export const formatFeatureFlagsToExperimentIdString = (
    featureFlags: FeatureFlag
): string =>
    Object.entries(featureFlags)
        .map(([key, value]) => `${key}:${value}`)
        .join(',')
